import React, { useEffect } from "react";
import { PhnSubscriptionPlanInterface } from "src/store/callrecorder/phnSubscriptionPlansSlice";

import { Button, Form, Input, InputNumber, Switch } from "antd";

interface propsInterface {
  params?: PhnSubscriptionPlanInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='name' label="Name" rules={[{ required: true, message: 'Name is required' }]}>
        <Input placeholder='Plan name' />
      </Form.Item>

      <Form.Item name='incoming_sms_limit' label="Incoming SMS Limit" rules={[{ required: true, message: 'SMS limit is required' }]}>
        <InputNumber placeholder='10' style={{ width: '100%' }} min={0} />
      </Form.Item>

      <Form.Item label="Active" name='active' valuePropName='checked'>
        <Switch
          checkedChildren='active'
          unCheckedChildren='inactive'
        />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
